import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m12 19.65-1.85 1.4q-.3.225-.6.012-.3-.212-.175-.562l.725-2.3-1.825-1.3q-.3-.2-.175-.55t.475-.35H10.8l.7-2.3-3.55-2.1a1.95 1.95 0 0 1-.7-.725Q7 10.425 7 9.85V4q0-.824.588-1.413A1.93 1.93 0 0 1 9 2h6q.824 0 1.413.587.586.589.587 1.413v5.85q0 .575-.25 1.025t-.7.725l-3.55 2.1.7 2.3h2.225q.35 0 .475.35t-.175.55L13.9 18.2l.725 2.3q.125.349-.175.563-.3.212-.6-.013zM9 4v5.85l2 1.2V4zm6 0h-2v7.05l2-1.2z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }